import { render, staticRenderFns } from "./Check.vue?vue&type=template&id=0f390a55&"
import script from "./Check.vue?vue&type=script&lang=ts&"
export * from "./Check.vue?vue&type=script&lang=ts&"
import style0 from "./Check.vue?vue&type=style&index=0&id=0f390a55&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports